import { ThemeProvider } from "@mui/material";
import React, { useContext, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import LoginPage from "./app/auth/login";
import EditConnectionsPage from "./app/marketingAgent/addConnections/EditConnection";
import ConnectionDetails from "./app/marketingAgent/allConnections/ConnectionDetails";
import ContractPreview from "./app/marketingAgent/contractPreview";
import AgentOffDaysPage from "./app/superadmin/agents/AgenOffDays";
import AdminChatPage from "./app/superadmin/dashboard/AdminChat";
import SnackbarAlert from "./components/snackbar";
import { AppContext } from "./lib/Context";
import { constants } from "./lib/Variable";
import { AdminRoutes, AgentRoute } from "./routes";
import { AuthLayout } from "./routes/AuthenticationLayout";
import { ProtectedLayout } from "./routes/ProtectedLayout";
import theme from "./theme";
import AddNewConnectionsPage from "./app/marketingAgent/addConnections";
import ServiceAgrement from "./components/serviceAgrement";

function App() {
  const { userData } = useContext(AppContext);
  const { pathname } = useLocation();


  const getRoutesByRole = () => {
    const isAdmin = userData?._id === process.env.REACT_APP_ADMIN_ID;

    let RenderAdminRoutes = isAdmin
      ? AdminRoutes
      : AdminRoutes.filter((route) => route.name !== "Admin" && route.name !== "Service Agrement");

    if (userData?.designation === "Admin") return RenderAdminRoutes;
    if (userData?.designation === "Sales Agent") return AgentRoute;
    return null;
  };

  const AllRoutes = getRoutesByRole();

  // const AllRoutes =
  //   userData?.designation === "Admin" ? AdminRoutes : AgentRoute;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <ThemeProvider theme={theme}>
      <Routes>
        <Route path="/login" element={<AuthLayout />}>
          <Route path={"/login"} element={<LoginPage />} />
        </Route>

        {/* Pathless layout + catch-all `*` so ProtectedLayout still runs when
            AllRoutes is empty (logged out) — otherwise inner URLs never match and
            users are not redirected to /login */}
        <Route element={<ProtectedLayout />}>
          {AllRoutes?.map(({ component: Component, path, id }) => (
            <Route key={id} path={path} element={Component} />
          ))}

          {userData?.designation === "Admin" && (
            <>
              <Route path={"/customer-support"} element={<AdminChatPage />} />
              <Route
                path={"/agent-calendar/:agentId"}
                element={<AgentOffDaysPage />}
              />
            </>
          )}

          <Route
            path={"/connection-details/:id"}
            element={<ConnectionDetails />}
          />
          <Route path={"/preview-contract"} element={<ContractPreview />} />
          <Route path={"/add-lead-admin"} element={<AddNewConnectionsPage />} />
          <Route path={"/edit-lead"} element={<EditConnectionsPage />} />
          <Route path={"/prospect-details"} element={<EditConnectionsPage />} />
          <Route
            path={"/service-agrement/:type/:id?"}
            element={<ServiceAgrement />}
          />
          <Route path="*" element={null} />
        </Route>
        {/* <Route  path="*" element={<NotFoundPage />} /> */}
      </Routes>
      <SnackbarAlert
        ref={(ref) => {
          constants.snackRef = ref;
        }}
      />
    </ThemeProvider>
  );
}

export default App;
